import { TonicWidget } from '@/ui';
import { getChannel, getDocument } from '@lib/server';
import { Place } from '@types';

import { BlockBase, Wrapper } from './utils';

export async function Tonic({
  params,
  id,
  ...data
}: {
  event: { id: string }[];
  date: { seconds: number };
} & BlockBase) {
  const channel = await getChannel(decodeURIComponent(params.domain));

  if (!channel?.channelId) {
    return null;
  }

  const { fields } = await getDocument<Place>('place', data.event?.[0]?.id, {
    tags: [channel.channelId],
    depth: 0,
    status: 'published',
    select: ['fields.apps.tonic'],
  });

  const tonicId = fields?.apps?.tonic?.id;

  if (!tonicId) {
    return null;
  }

  const formatDate = (seconds: number) => {
    if (!seconds) {
      return null;
    }
    const date = new Date(seconds * 1000); // Convert seconds to milliseconds
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Adding 1 to month because months are zero-based
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}${month}${day}`;
  };

  return (
    <Wrapper id={id}>
      <TonicWidget
        className="relative! z-10 flex h-full min-h-[800px] w-full max-w-xl items-center justify-center overflow-x-hidden overflow-y-auto"
        itemIds={tonicId}
        date={formatDate(data?.date?.seconds) || ''}
        affiliateId={fields.apps.tonic.affiliateId}
        useLatest={fields.apps.tonic.useNewWidget ? true : false}
      />
    </Wrapper>
  );
}
